<template lang="html">

  <li
    :class="['pe_clue', {'pe_selected': isSelected, 'pe_correct': clue.isWordCorrect() && gameMode === 'quick' }]"
    @click="highlightClueOnGrid(clue)"
    v-show="isPlaying || completed"
    ref="clue"
  >
    <span>{{ clue.clueNumber }}. <span v-html="clue.clue"></span></span> 
  </li>

</template>

<script lang="js">

  import { mapState, mapActions } from 'vuex'

  export default  {
    name: 'clue',
    props: ['clue'],

    methods: {
      ...mapActions({
        highlightClueOnGrid: 'cluelist/highlightClueOnGrid'
      }),

      scrollTo() {        
        if (this.$refs.clue)
          this.$emit('scroll-to', this.$refs.clue)
        // this.$nextTick(() => this.$refs.clue.scrollIntoView({ block: 'center' }))
      },

      move(elem) {
        var left = 0
        function frame() {
          left++  // update parameters
          elem.style.left = left + 'px' // show frame
          if (left == 100)  // check finish condition
            clearInterval(id)
        }
        var id = setInterval(frame, 10) // draw every 10ms
      },

    },

    computed: {

      ...mapState({
        isAcross: state => state.grid.isAcross,
        // selectedCell: state => state.grid.selectedCell,
        selectedClues: state => state.cluelist.selected,
        isPlaying: state => state.game.isPlaying,
        completed: state => state.game.completed,
        gameMode: state => state.userSettings.gameMode,
      }),

      isSelected() {
        let selected = this.clue === this.selectedClues.across || 
                       this.clue === this.selectedClues.down

        if (selected) 
          this.scrollTo()

        return selected
      },


    }
}


</script>

<style scoped lang="scss">

  @import '@puzzleapps/shared/src/style/variables';

  .pe_clue {
    font-size: 0.9em;

    @media (max-width: $max-container-size) {
      font-size: 0.8em;
      padding: 0.3em;
    }

    &.pe_correct {
      text-decoration: line-through;
      opacity: 0.7;
      color: #616161;
      span {
        color: #0f1113;
      }
    }
  }
</style>
